import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { AnalyticsEventObject } from '../../models/analytics-event.model';
import { FormSectionsStateModel } from '../../models/form-sections-state-default';
import { SuccessModel } from '../../models/success-mock';
import { CallAxaOptOut, ResetGlobalState, SendAnalyticsEvent } from '../../onboarding.actions';
import { OnboardingGlobalStateModel } from '../../onboarding.state';
import { OptoutTravelRenewalVoyageRequest } from '../../../clients/clients';
import { ApplicationType } from '../form-sections/form-intro/form-intro.component';
import { QueryFormType } from '../form-sections/form-navigation/form-navigation.component';
import { ResetState } from '../form-sections/form-sections.actions';

interface StoreModel {
  onbGlobalState: OnboardingGlobalStateModel;
  onbFormSectionsState: FormSectionsStateModel;
}

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
  standalone: false,
})
export class SuccessComponent implements OnInit, OnDestroy {
  public successModel: SuccessModel = {
    urlRefNum: null,
    refKey: null,
    imageTitle: null,
    urlTitle: null
  };
  public axaOtpOutModel: OptoutTravelRenewalVoyageRequest = {
    referenceNumber: null,
    firstName: null,
    surname: null
  };
  public axaOtpOutValue = false;
  public isLoading = false;
  public optOutSuccess = false;
  public formType: string;
  QueryFormType = QueryFormType; // exposing enum
  private storeSubscription: Subscription;

  constructor(private route: ActivatedRoute, private store: Store, private router: Router) {
  }

  ngOnInit(): void {
    const type = this.store.selectSnapshot((res: StoreModel) => res.onbFormSectionsState.formType);

    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if (event.navigationTrigger === 'popstate') {
          this.router.navigate(['/'], {
            queryParams: { form: type }
          });
        }
      }
    });

    this.storeSubscription = this.store.subscribe((res: StoreModel) => {
      this.formType = res.onbFormSectionsState.formType;
      this.optOutSuccess = res.onbGlobalState.axaOptOutUploadSuccess;
      if (this.optOutSuccess) {
        window.scroll(0, 0);
        this.isLoading = false;
        this.axaOtpOutValue = false;
      }
      if (res.onbGlobalState.hasAPIErrors !== null) {
        this.isLoading = false;
      }
    });

    this.successModel.urlRefNum = this.route.snapshot.queryParamMap.get('refNum');
    this.successModel.refKey = this.successModel.urlRefNum.substring(2, 5);

    if (this.successModel.refKey.toLocaleUpperCase() === 'VOY') {
      this.successModel.urlTitle = 'Voyage Account Application';
      this.successModel.imageTitle = 'Zeb3_VOYAGE_2x';
    } else if (this.successModel.refKey.toLocaleUpperCase() === 'CAA') {
      this.successModel.urlTitle = 'Currency Access Account';
      this.successModel.imageTitle = 'Zeb2_CURRENCY ACCESS_2x';
    } else if (this.successModel.refKey.toLocaleUpperCase() === 'PBA') {
      this.successModel.urlTitle = 'Private Bank Account Application';
      this.successModel.imageTitle = 'Zeb1_PBA_2x';
    }

    this.sendAnalyticsEvent(this.store.selectSnapshot((res: StoreModel) => res.onbFormSectionsState));
  }

  sendAnalyticsEvent(state: FormSectionsStateModel): void {
    const data: AnalyticsEventObject = {
      event: 'application',
      action: 'complete',
      page: {
        form: {
          name: 'UK' + this.successModel.refKey.toLocaleUpperCase(),
          applicationType:
            state.applicationType === ApplicationType.SOLE
              ? 'Individual'
              : state.applicationType === ApplicationType.JOINT
                ? 'Joint'
                : 'Company',
          leadID: this.successModel.urlRefNum,
          section: 'form submission',
          stepName: 'application submitted'
        }
      }
    };

    this.store.dispatch(new SendAnalyticsEvent(data));
  }

  toggleOptOut(value: boolean): void {
    this.axaOtpOutValue = value;
  }

  handleOtpOutSubmit(): void {
    this.isLoading = true;
    const state = this.store.selectSnapshot((res: StoreModel) => res.onbFormSectionsState);
    this.axaOtpOutModel.firstName = state.currentFormData.Applicants[0].FirstName;
    this.axaOtpOutModel.surname = state.currentFormData.Applicants[0].Surname;
    this.axaOtpOutModel.referenceNumber = state.referenceNumber;
    this.store.dispatch(new CallAxaOptOut(this.axaOtpOutModel));
  }

  ngOnDestroy(): void {
    if (this.storeSubscription) {
      this.storeSubscription.unsubscribe();
    }
    this.store.dispatch([new ResetGlobalState(), new ResetState()]);
  }
}
